import React from 'react';
import { Switch, Route } from "react-router-dom";
import HomePage from "../../HomePage";
import LoginPage from "../../LoginPage";
import NotFoundPage from "../../NotFoundPage";
import OAuth from '../../OAuth';
import { Grid } from '@material-ui/core';


export default function AnonymousRoutes(props) {
    const { user, userData, theme, openSnackbar, appSettings } = props;
    return <Grid container spacing={2}>
        <Grid item xs={12}>
            <Switch>
                <Route path="/" exact>
                    <HomePage user={user} openSnackbar={openSnackbar} appSettings={appSettings} />
                </Route>
                <Route path="/login" exact>
                    <LoginPage loginStep='login' openSnackbar={openSnackbar} appSettings={appSettings} />
                </Route>
                <Route path="/mobileLogin" exact>
                    <LoginPage loginStep='mobileLogin' openSnackbar={openSnackbar} appSettings={appSettings} />
                </Route>
                <Route path="/signUp" exact>
                    <LoginPage loginStep='signUp' openSnackbar={openSnackbar} appSettings={appSettings} />
                </Route>
                <Route path="/initResetPassword" exact>
                    <LoginPage loginStep='initResetPassword' openSnackbar={openSnackbar} appSettings={appSettings} />
                </Route>
                <Route path="/initiateResetPassword" exact>
                    <LoginPage loginStep='initiateResetPassword' openSnackbar={openSnackbar} appSettings={appSettings} />
                </Route>
                <Route path="/oauth">
                    <OAuth
                        user={user}
                        userData={userData}
                        theme={theme}
                        openSnackbar={openSnackbar} />
                </Route>
                <Route>
                    <NotFoundPage />
                </Route>
            </Switch>
        </Grid>
    </Grid>
}